import { loadView } from '@/helper/utils'
import { mainLayout } from '@/components/layouts/Main'

export default {
  path: '/point',
  component: mainLayout(loadView('point/Point')),
  children: [
    {
      path: '',
      name: 'PointPurchase',
      component: loadView('point/PointPurchase'),
      meta: { requiresAuth: true }
    },
    {
      path: 'bank',
      name: 'PointBank',
      component: loadView('point/bank/PointBank'),
      meta: { requiresAuth: true }
    },
    {
      path: 'bank_telecom',
      component: loadView('point/bank_telecom/PointBankTelecom'),
      children: [
        {
          path: '',
          name: 'PointBankTelecomForm',
          component: loadView('point/bank_telecom/PointBankTelecomForm'),
          meta: { requiresAuth: true }
        },
        {
          path: 'confirm',
          name: 'PointBankTelecomConfirm',
          component: loadView('point/bank_telecom/PointBankTelecomConfirm'),
          meta: { requiresAuth: true },
          props: true
        },
        {
          path: 'application_complete',
          name: 'PointBankTelecomApplicationComplete',
          component: loadView('point/bank_telecom/PointBankTelecomApplicationComplete'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: 'credit/:paymentWay',
      component: loadView('point/credit/PointCredit'),
      children: [
        {
          path: '',
          name: 'PointCreditForm',
          component: loadView('point/credit/PointCreditForm'),
          meta: { requiresAuth: true }
        },
        {
          path: 'confirm',
          name: 'PointCreditConfirm',
          component: loadView('point/credit/PointCreditConfirm'),
          meta: { requiresAuth: true },
          props: true
        },
        {
          path: 'complete',
          name: 'PointCreditComplete',
          component: loadView('point/credit/PointCreditComplete')
        },
        {
          path: 'cancel',
          name: 'PointCreditCancel',
          component: loadView('point/credit/PointCreditCancel')
        },
        {
          path: 'error',
          name: 'PointCreditError',
          component: loadView('point/credit/PointCreditError')
        }
      ]
    },
    {
      path: 'credit_telecom',
      component: loadView('point/credit_telecom/PointCreditTelecom'),
      children: [
        {
          path: '',
          name: 'PointCreditTelecomForm',
          component: loadView('point/credit_telecom/PointCreditTelecomForm'),
          meta: { requiresAuth: true }
        },
        {
          path: 'confirm',
          name: 'PointCreditTelecomConfirm',
          component: loadView('point/credit_telecom/PointCreditTelecomConfirm'),
          meta: { requiresAuth: true },
          props: true
        },
        {
          path: 'complete',
          name: 'PointCreditTelecomComplete',
          component: loadView('point/credit_telecom/PointCreditTelecomComplete')
        },
        {
          path: 'cancel',
          name: 'PointCreditTelecomCancel',
          component: loadView('point/credit_telecom/PointCreditTelecomCancel')
        },
        {
          path: 'error',
          name: 'PointCreditTelecomError',
          component: loadView('point/credit_telecom/PointCreditTelecomError')
        }
      ]
    },
    {
      path: 'credit_tc',
      component: loadView('point/credit_tc/PointCreditTechcoin'),
      children: [
        {
          path: '',
          name: 'PointCreditTechcoinForm',
          component: loadView('point/credit_tc/PointCreditTechcoinForm'),
          meta: { requiresAuth: true }
        },
        {
          path: 'confirm',
          name: 'PointCreditTechcoinConfirm',
          component: loadView('point/credit_tc/PointCreditTechcoinConfirm'),
          meta: { requiresAuth: true },
          props: true
        },
        {
          path: 'complete',
          name: 'PointCreditTechcoinComplete',
          component: loadView('point/credit_tc/PointCreditTechcoinComplete')
        },
        {
          path: 'cancel',
          name: 'PointCreditTechcoinCancel',
          component: loadView('point/credit_tc/PointCreditTechcoinCancel')
        },
        {
          path: 'error',
          name: 'PointCreditTechcoinError',
          component: loadView('point/credit_tc/PointCreditTechcoinError')
        }
      ]
    },
    {
      path: 'bitcash',
      component: loadView('point/bitcash/PointBitcash'),
      children: [
        {
          path: '',
          name: 'PointBitcashForm',
          component: loadView('point/bitcash/PointBitcashForm'),
          meta: { requiresAuth: true }
        },
        {
          path: 'confirm',
          name: 'PointBitcashConfirm',
          component: loadView('point/bitcash/PointBitcashConfirm'),
          meta: { requiresAuth: true },
          props: true
        },
        {
          path: 'complete',
          name: 'PointBitcashComplete',
          component: loadView('point/bitcash/PointBitcashComplete')
        },
        {
          path: 'cancel',
          name: 'PointBitcashCancel',
          component: loadView('point/bitcash/PointBitcashCancel')
        },
        {
          path: 'error',
          name: 'PointBitcashError',
          component: loadView('point/bitcash/PointBitcashError')
        },
        {
          path: ':store',
          name: 'PointBitcashStore',
          component: loadView('point/bitcash/PointBitcashStore'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: 'netridecash',
      component: loadView('point/netridecash/PointNetridecash'),
      children: [
        {
          path: '',
          name: 'PointNetridecashForm',
          component: loadView('point/netridecash/PointNetridecashForm'),
          meta: { requiresAuth: true }
        },
        {
          path: 'confirm',
          name: 'PointNetridecashConfirm',
          component: loadView('point/netridecash/PointNetridecashConfirm'),
          meta: { requiresAuth: true },
          props: true
        },
        {
          path: 'complete',
          name: 'PointNetridecashComplete',
          component: loadView('point/netridecash/PointNetridecashComplete')
        },
        {
          path: 'cancel',
          name: 'PointNetridecashCancel',
          component: loadView('point/netridecash/PointNetridecashCancel')
        },
        {
          path: 'error',
          name: 'PointNetridecashError',
          component: loadView('point/netridecash/PointNetridecashError')
        },
        {
          path: ':store',
          name: 'PointNetridecashStore',
          component: loadView('point/netridecash/PointNetridecashStore'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: 'netridecash_tc',
      component: loadView('point/netridecash_tc/PointNetridecashTechcoin'),
      children: [
        {
          path: '',
          name: 'PointNetridecashTechcoinForm',
          component: loadView('point/netridecash_tc/PointNetridecashTechcoinForm'),
          meta: { requiresAuth: true }
        },
        {
          path: 'confirm',
          name: 'PointNetridecashTechcoinConfirm',
          component: loadView('point/netridecash_tc/PointNetridecashTechcoinConfirm'),
          meta: { requiresAuth: true },
          props: true
        },
        {
          path: 'complete',
          name: 'PointNetridecashTechcoinComplete',
          component: loadView('point/netridecash_tc/PointNetridecashTechcoinComplete')
        },
        {
          path: 'cancel',
          name: 'PointNetridecashTechcoinCancel',
          component: loadView('point/netridecash_tc/PointNetridecashTechcoinCancel')
        },
        {
          path: 'error',
          name: 'PointNetridecashTechcoinError',
          component: loadView('point/netridecash_tc/PointNetridecashTechcoinError')
        },
        {
          path: ':store',
          name: 'PointNetridecashTechcoinStore',
          component: loadView('point/netridecash_tc/PointNetridecashTechcoinStore'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: 'securitymoney',
      component: loadView('point/securitymoney/PointSecuritymoney'),
      children: [
        {
          path: '',
          name: 'PointSecuritymoneyForm',
          component: loadView('point/securitymoney/PointSecuritymoneyForm'),
          meta: { requiresAuth: true }
        },
        {
          path: 'confirm',
          name: 'PointSecuritymoneyConfirm',
          component: loadView('point/securitymoney/PointSecuritymoneyConfirm'),
          meta: { requiresAuth: true },
          props: true
        },
        {
          path: 'complete',
          name: 'PointSecuritymoneyComplete',
          component: loadView('point/securitymoney/PointSecuritymoneyComplete')
        },
        {
          path: 'cancel',
          name: 'PointSecuritymoneyCancel',
          component: loadView('point/securitymoney/PointSecuritymoneyCancel')
        },
        {
          path: 'error',
          name: 'PointSecuritymoneyError',
          component: loadView('point/securitymoney/PointSecuritymoneyError')
        }
      ]
    },
    {
      path: 'gmoney',
      component: loadView('point/gmoney/PointGmoney'),
      children: [
        {
          path: '',
          name: 'PointGmoneyForm',
          component: loadView('point/gmoney/PointGmoneyForm'),
          meta: { requiresAuth: true }
        },
        {
          path: 'confirm',
          name: 'PointGmoneyConfirm',
          component: loadView('point/gmoney/PointGmoneyConfirm'),
          meta: { requiresAuth: true },
          props: true
        },
        {
          path: 'complete',
          name: 'PointGmoneyComplete',
          component: loadView('point/gmoney/PointGmoneyComplete')
        },
        {
          path: 'cancel',
          name: 'PointGmoneyCancel',
          component: loadView('point/gmoney/PointGmoneyCancel')
        },
        {
          path: 'error',
          name: 'PointGmoneyError',
          component: loadView('point/gmoney/PointGmoneyError')
        }
      ]
    },
    {
      path: 'bank_anotherlane',
      component: loadView('point/bank_anotherlane/PointBankAnotherlane'),
      children: [
        {
          path: '',
          name: 'PointBankAnotherlaneForm',
          component: loadView('point/bank_anotherlane/PointBankAnotherlaneForm'),
          meta: { requiresAuth: true }
        },
        {
          path: 'confirm',
          name: 'PointBankAnotherlaneConfirm',
          component: loadView('point/bank_anotherlane/PointBankAnotherlaneConfirm'),
          meta: { requiresAuth: true },
          props: true
        },
        {
          path: 'application_complete',
          name: 'PointBankAnotherlaneApplicationComplete',
          component: loadView('point/bank_anotherlane/PointBankAnotherlaneComplete'),
          meta: { requiresAuth: true },
          props: true
        },
        {
          path: 'error',
          name: 'PointBankAnotherlaneError',
          component: loadView('point/bank_anotherlane/PointBankAnotherlaneError'),
          meta: { requiresAuth: true },
          props: true
        }
      ]
    },
    {
      path: 'gpay',
      component: loadView('point/gpay/PointGpay'),
      children: [
        {
          path: '',
          name: 'PointGpayForm',
          component: loadView('point/gpay/PointGpayForm'),
          meta: { requiresAuth: true }
        },
        {
          path: 'confirm',
          name: 'PointGpayConfirm',
          component: loadView('point/gpay/PointGpayConfirm'),
          meta: { requiresAuth: true },
          props: true
        },
        {
          path: 'complete',
          name: 'PointGpayComplete',
          component: loadView('point/gpay/PointGpayComplete')
        },
        {
          path: 'cancel',
          name: 'PointGpayCancel',
          component: loadView('point/gpay/PointGpayCancel')
        },
        {
          path: 'error',
          name: 'PointGpayError',
          component: loadView('point/gpay/PointGpayError')
        }
      ]
    }
  ]
}
